export const SettingTypes =  {
  custom: 'custom',
  input: 'input',
  boolean: 'boolean',
  radio_button: 'radio-button',
  color_picker: 'color-picker',
  switch: 'switch',
  slider: 'slider',
  select: 'select',
  goods_selector: 'goods-selector',
  link: 'link'
}

export default SettingTypes
